import { CSSProperties } from 'react';
import storage from '@/utils/storage';

export const CheckboxSelected = ({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties | undefined;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <g id="Group_2479" data-name="Group 2479" transform="translate(-940 -695)">
      <rect
        id="Rectangle_2059"
        data-name="Rectangle 2059"
        width="24"
        height="24"
        transform="translate(940 695)"
        fill="none"
      />
      <g id="Group_2478" data-name="Group 2478" transform="translate(918 36)">
        <g id="Group_2438" data-name="Group 2438" transform="translate(24 661)">
          <g id="Group_2412" data-name="Group 2412">
            <rect
              id="Rectangle_263"
              data-name="Rectangle 263"
              width="20"
              height="20"
              rx="2"
              fill={storage.getItem('primaryColor') ?? ''}
            />
          </g>
        </g>
        <path
          id="Path_20032"
          data-name="Path 20032"
          d="M2537.573,1783.949h-.107a1.154,1.154,0,0,1-.8-.453l-2.16-2.969a1.119,1.119,0,1,1,1.777-1.315l1.413,1.938,5.616-5.261a1.12,1.12,0,1,1,1.529,1.635l-6.54,6.123A1.1,1.1,0,0,1,2537.573,1783.949Z"
          transform="translate(-2505.255 -1108.773)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);
